import { Fragment } from "react";
import { Grid } from "@mui/material";

import DatePickerComponent from "./custom fields/date dialog components/DatePicker";
import SwitchComponent from "./custom fields/switch dialog components/SwitchComponent";
import TextFieldComponent from "./custom fields/textfield dialog components/TextFieldComponent";
import DropDownComponent from "./custom fields/dropdown dialog components/DropdownComponent";

export default function CustomField({
  formikProps,
  customFields,
  visitorDataIndex,
  name = undefined,
}) {
  return (
    <Fragment>
      {customFields.map((item, index) => {
        return (
          <Fragment>
            {item.control_id === "61dd2dfa1fb38be82e077ed7" && (
              <Grid item xs={12} sx={{ mt: index === 0 ? "0px" : "15px" }}>
                <TextFieldComponent
                  name={name && `${name}${item.name}`}
                  fieldDetails={item}
                  formikProps={formikProps}
                  disabled={!item.editable}
                />
              </Grid>
            )}

            {item.control_id === "61dd2dfa1fb38be82e077ed9" && (
              <Grid item xs={12} sx={{ mt: index === 0 ? "0px" : "15px" }}>
                <DatePickerComponent
                  name={name && `${name}${item.name}`}
                  formikProps={formikProps}
                  fieldDetails={item}
                  disabled={!item.editable}
                />
              </Grid>
            )}

            {item.control_id === "61dd2dfa1fb38be82e077ed8" && (
              <Grid item xs={12} sx={{ mt: index === 0 ? "0px" : "15px" }}>
                <DropDownComponent
                  name={name && `${name}${item.name}`}
                  formikProps={formikProps}
                  fieldDetails={item}
                  disabled={!item.editable}
                />
              </Grid>
            )}

            {item.control_id === "61e13a0bf2c60729b06385f3" && (
              <Grid item xs={12} sx={{ mt: index === 0 ? "0px" : "15px" }}>
                <SwitchComponent
                  name={name && `${name}${item.name}`}
                  formikProps={formikProps}
                  fieldDetails={item}
                  disabled={!item.editable}
                />
              </Grid>
            )}
          </Fragment>
        );
      })}
    </Fragment>
  );
}
